import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation } from '@tanstack/react-query'
import { QueryKey } from '../../domain/enums/query-key.enum'
import { PutOffer } from '../../usecases/put-offer.usecase'
import { OfferSchemaValidationType } from '../validations/offer-validation'

export const usePutOffer = ({
  id,
  onSuccess,
  onError,
}: {
  id: string
  onSuccess?: () => void
  onError?: (error) => void
}) => {
  const container = useContainer()

  return useMutation(
    [QueryKey.putOffer],
    (input: OfferSchemaValidationType) =>
      new PutOffer(container.get(HttpClient)).execute({
        ...input,
        id,
      }),
    {
      retry: false,
      onSuccess,
      onError: (error) => {
        if (onError) {
          onError(error)
        }
      },
    },
  )
}
